import { msg } from '@lingui/core/macro';

export const ELEMENTS_DATA_INDEX = {
    ID: 'id',
    ELEMENT_ID: 'elementId',
    CREATOR_REF: 'creatorReference',
    TYPE: 'type',
    ELEMENT: 'title',
    USED_IN_PATHWAYS: 'totalUsedInPathways',
    VERSION: 'version',
    STATUS: 'status',
} as const;

export const ELEMENTS_COLUMN_TITLE = {
    ID: msg`ID`,
    CREATOR_REF: msg`Creator Ref.`,
    TYPE: msg`Type`,
    ELEMENT: msg`Element`,
    USED_IN_PATHWAYS: msg`Used in Pathways`,
    VERSION: msg`Version`,
    STATUS: msg`Status`,
} as const;

export const ELEMENTS_COLUMN_SORT_MAP: Record<string, string> = {
    [ELEMENTS_DATA_INDEX.ELEMENT_ID]: ELEMENTS_DATA_INDEX.ELEMENT_ID,
    [ELEMENTS_DATA_INDEX.CREATOR_REF]: ELEMENTS_DATA_INDEX.CREATOR_REF,
    [ELEMENTS_DATA_INDEX.TYPE]: ELEMENTS_DATA_INDEX.TYPE,
    [ELEMENTS_DATA_INDEX.ELEMENT]: ELEMENTS_DATA_INDEX.ELEMENT,
    [ELEMENTS_DATA_INDEX.USED_IN_PATHWAYS]: ELEMENTS_DATA_INDEX.USED_IN_PATHWAYS,
    [ELEMENTS_DATA_INDEX.VERSION]: ELEMENTS_DATA_INDEX.VERSION,
    [ELEMENTS_DATA_INDEX.STATUS]: ELEMENTS_DATA_INDEX.STATUS,
};

export const ELEMENTS_COLUMN_FILTER_MAP: Record<string, string> = {
    [ELEMENTS_DATA_INDEX.TYPE]: ELEMENTS_DATA_INDEX.TYPE,
    [ELEMENTS_DATA_INDEX.STATUS]: ELEMENTS_DATA_INDEX.STATUS,
};

export const EDIT_ELEMENT_KEY = 'edit-element';
export const PUBLISH_ELEMENT_KEY = 'publish-element';
export const ARCHIVE_ELEMENT_KEY = 'archive-element';
export const DELETE_ELEMENT_KEY = 'delete-element';
export const OPEN_ELEMENT_KEY = 'open-element';
export const DRAFT_STATUS = 'Draft';
export const ARCHIVE_STATUS = 'Archive';
export const PUBLISHED_STATUS = 'Published';

export const ELEMENTS_STATUSES = {
    DRAFT_STATUS,
    ARCHIVE_STATUS,
    PUBLISHED_STATUS,
};
